(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_maxsmile-offers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('maxsmile-offers')) {
    customElements.define('maxsmile-offers', class extends HTMLElement {
      connectedCallback() {
        const delivery = this.closest('.shopify-section')?.querySelector('maxsmile-delivery');
        if (delivery && this.parentElement !== delivery.parentElement) {
          delivery.before(this);
          return;
        }
        if (this.bound) return;
        this.bound = true;
        this.purchase = this.closest('.shopify-section')?.querySelector('maxsmile-purchase');
        const refreshPrice = () => {
          const total = Number(this.purchase?.dataset.offerTotal);
          if (Number.isFinite(total) && this.purchase?.dataset.offerTotal) this.querySelector('[data-best-price]').textContent = new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format(Math.max(0,total-9500)/100);
        };
        refreshPrice();
        this.priceHandler = refreshPrice;
        this.purchase?.addEventListener('maxsmile:price',this.priceHandler);

        this.addEventListener('click', async (event) => {
          const apply = event.target.closest('[data-apply-code]');
          if(apply && this.contains(apply)) {
            document.cookie = 'discount_code=' + encodeURIComponent(apply.dataset.applyCode) + ';path=/;max-age=14400;SameSite=Lax;Secure';
            this.querySelectorAll('[data-apply-code]').forEach(button=>button.textContent='Apply');
            apply.textContent='Opening…';
            apply.disabled=true;
            this.querySelector('[data-copy-status]').textContent=apply.dataset.applyCode+' selected for checkout. Use FIRSTORDER for your first-order saving.';
            const checkout=this.purchase?.querySelector('[data-destination="checkout"]');
            if(checkout && !checkout.disabled) {
              await this.purchase.submit({preventDefault(){},submitter:checkout});
              this.querySelector('[data-copy-status]').textContent='Selected '+apply.dataset.applyCode+'. Checkout confirms eligibility and the final discount.';
            } else {
              this.querySelector('[data-copy-status]').textContent='Checkout is not ready. Please use Buy now to continue.';
            }
            apply.disabled=false;
            apply.textContent='Apply';
            return;
          }
          const button = event.target.closest('[data-copy-code]');
          if (!button || !this.contains(button)) return;
          const status = this.querySelector('[data-copy-status]');
          try {
            await navigator.clipboard.writeText(button.dataset.copyCode);
            button.querySelector('[data-copy-text]').textContent = button.dataset.copiedLabel;
            status.textContent = button.dataset.copiedLabel + ': ' + button.dataset.copyCode;
            clearTimeout(this.copyTimeout);
            this.copyTimeout = setTimeout(() => {
              button.querySelector('[data-copy-text]').textContent = button.dataset.copyLabel;
            }, 2500);
          } catch (error) {
            status.textContent = button.dataset.copyError + ' ' + button.dataset.copyCode;
            button.querySelector('[data-copy-text]').textContent = button.dataset.copyError;
          }
        });
      }
      disconnectedCallback() { clearTimeout(this.copyTimeout); this.purchase?.removeEventListener("maxsmile:price",this.priceHandler); this.bound=false; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_maxsmile-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('maxsmile-purchase')) {
    customElements.define('maxsmile-purchase', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.error = this.querySelector('.mp-error');
        this.buttons = Array.from(this.querySelectorAll('[data-destination]'));
        this.radios = Array.from(this.form.querySelectorAll('input[name="quantity"][type="radio"]'));
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style:'currency', currency:this.dataset.currency, currencyDisplay:'narrowSymbol', minimumFractionDigits:0, maximumFractionDigits:this.dataset.currency === 'INR' ? 0 : 2 });
        this.fractionMoney = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style:'currency', currency:this.dataset.currency, currencyDisplay:'narrowSymbol', minimumFractionDigits:2, maximumFractionDigits:2 });
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.form.addEventListener('change', event => {
          this.error.hidden = true;
          this.update(event.target.name === 'id');
        }, { signal });
        this.form.addEventListener('submit', event => this.submit(event), { signal });
        document.addEventListener('maxsmile:bundle', event => {
          if (event.detail.productId !== this.dataset.productId) return;
          this.addons = event.detail.items;
          this.renderSticky();
        }, { signal });
        window.addEventListener('pageshow', () => {
          this.busy = false;
          this.removeAttribute('aria-busy');
          this.update(false);
        }, { signal });
        this.update(false);
        this.startCountdown();

      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.observer?.disconnect();
        window.clearTimeout(this.galleryTimer);
        window.clearInterval(this.countdownTimer);
        this.initialized = false;
      }
      startCountdown() {
        window.clearInterval(this.countdownTimer);
        this.timerExpired = false;
        this.countdown = this.querySelector('[data-countdown]');
        if (!this.countdown) return;
        this.countdown.hidden = true;
        const settings = this.countdown.dataset;
        let deadline = NaN;
        if (settings.mode === 'fixed') {
          const value = settings.deadline.trim();
          const parts = value.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})$/);
          if (parts) {
            const [, year, month, day, hours, minutes, seconds = '0', zone] = parts;
            const lastDay = new Date(Date.UTC(Number(year), Number(month), 0)).getUTCDate();
            const validZone = zone === 'Z' || (Number(zone.slice(1, 3)) <= 23 && Number(zone.slice(4)) <= 59);
            if (Number(month) >= 1 && Number(month) <= 12 && Number(day) >= 1 && Number(day) <= lastDay && Number(hours) <= 23 && Number(minutes) <= 59 && Number(seconds) <= 59 && validZone) deadline = Date.parse(value);
          }
        } else {
          const duration = Number(settings.hours) * 60 * 60 * 1000;
          const campaign = settings.campaign.trim();
          if (duration > 0 && campaign) {
            const key = `maxsmile:quantity-offer:${encodeURIComponent(campaign)}`;
            for (const storageName of ['localStorage', 'sessionStorage']) {
              try {
                const storage = window[storageName];
                const existing = Number(storage.getItem(key));
                if (Number.isFinite(existing) && existing > 0) {
                  deadline = existing;
                  break;
                }
                const nextDeadline = Date.now() + duration;
                storage.setItem(key, String(nextDeadline));
                if (storage.getItem(key) === String(nextDeadline)) {
                  deadline = nextDeadline;
                  break;
                }
              } catch {}
            }
          }
        }
        if (!Number.isFinite(deadline)) return;
        this.countdownDeadline = deadline;
        this.tickCountdown();
        if (!this.timerExpired) this.countdownTimer = window.setInterval(() => this.tickCountdown(), 1000);
      }
      tickCountdown() {
        if (!this.countdown || !Number.isFinite(this.countdownDeadline)) return;
        const remaining = Math.ceil((this.countdownDeadline - Date.now()) / 1000);
        this.countdown.hidden = false;
        if (remaining <= 0) {
          window.clearInterval(this.countdownTimer);
          this.timerExpired = true;
          this.countdown.hidden = true;
          return;
        }
        const values = {
          hours:String(Math.floor(remaining / 3600)).padStart(2, '0'),
          minutes:String(Math.floor(remaining % 3600 / 60)).padStart(2, '0'),
          seconds:String(remaining % 60).padStart(2, '0')
        };
        this.countdown.textContent = this.countdown.dataset.format.replace(/\{(hours|minutes|seconds)\}/g, (_, key) => values[key]);
      }
      format(cents) { return (this.dataset.currency === 'INR' || cents % 100 === 0 ? this.money : this.fractionMoney).format(cents / 100); }
      variant() { return this.variants.find(variant => String(variant.id) === this.form.elements.id.value); }
      total(variant, input) {
        const quantity = Number(input?.value || 1);
        const discount = Number(input?.dataset.discount || 0);
        return { quantity, discount, regular:variant.price * quantity, total:Math.round(variant.price * quantity * (100 - discount) / 100) };
      }
      update(changedVariant) {
        const variant = this.variant();
        if (!variant) return;
        const rule = variant.quantity_rule || { min:1, increment:1 };
        for (const input of this.radios) {
          const quantity = Number(input.value);
          input.closest('.mp-card-option').hidden = false;
          input.disabled = !variant.available || quantity < (rule.min || 1) || (rule.max != null && quantity > rule.max) || quantity % (rule.increment || 1) !== 0;
          const amounts = this.total(variant, input);
          const card = input.nextElementSibling;
          card.querySelector('[data-card-price]').textContent = this.format(amounts.total);
          const savings = card.querySelector('[data-card-saving]');
          savings.hidden = amounts.regular <= amounts.total;
          savings.textContent = `${this.dataset.saveLabel} ${this.format(amounts.regular - amounts.total)} ${this.dataset.saveSuffix || ''}`.trim();
        }
        let selected = this.form.querySelector('input[name="quantity"]:checked') || this.form.querySelector('input[name="quantity"][type="hidden"]:not(:disabled)');
        if (selected?.disabled && this.radios.some(input => !input.disabled)) {
          selected.checked = false;
          selected = this.radios.find(input => !input.disabled);
          selected.checked = true;
        }
        const visibleOffers = this.radios.filter(input => !input.closest('.mp-card-option').hidden).length;
        const offers = this.querySelector('.mp-offers');
        if (offers) {
          offers.hidden = visibleOffers === 0;
          this.querySelector('.mp-card-grid').style.setProperty('--mp-count', visibleOffers);
        }
        const amounts = this.total(variant, selected);
        this.dataset.offerTotal=String(amounts.total);
        this.dispatchEvent(new CustomEvent("maxsmile:price"));
        const compare = Math.max(variant.compare_at_price || 0, variant.price) * amounts.quantity;
        this.querySelector('[data-total]').textContent = this.format(amounts.total);
        this.querySelector('[data-compare]').textContent = this.format(compare);
        this.querySelector('[data-compare-wrap]').hidden = compare <= amounts.total;
        this.querySelector('[data-compare-label]').hidden = !(variant.compare_at_price > variant.price);
        const percent = compare > 0 ? Math.round((compare - amounts.total) * 100 / compare) : 0;
        this.querySelector('[data-discount]').textContent = percent;
        this.querySelector('[data-discount-wrap]').hidden = percent <= 0;
        this.selection = { productId:this.dataset.productId, id:variant.id, quantity:amounts.quantity, total:amounts.total, regular:amounts.regular, compare, available:variant.available };
        this.dispatchEvent(new CustomEvent('maxsmile:selection', { bubbles:true, detail:this.selection }));
        this.renderSticky();
        const available = variant.available && selected && !selected.disabled;
        for (const button of this.buttons) {
          button.disabled = this.busy || !available;
          button.querySelector('[data-button-label]').textContent = this.busy ? this.dataset.loading : available ? button.dataset.availableLabel : this.dataset.soldOut;
        }
        if (changedVariant) {
          const url = new URL(location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
          this.syncGallery(variant);
        }
      }
      bundleTotals(items = []) {
        const main = this.selection;
        if (!main) return null;
        const count = main.quantity + items.reduce((sum,item) => sum + item.quantity, 0);
        const regular = main.regular + items.reduce((sum,item) => sum + item.price * item.quantity, 0);
        const rate = items.length ? (count >= 4 ? 25 : count >= 2 ? 15 : 0) : 0;
        const total = items.length ? Math.round(regular * (100 - rate) / 100) : main.total;
        return { count, regular, total, rate, saving: regular - total };
      }
      renderSticky() {
        const main = this.selection;
        const target = this.querySelector('[data-sticky-total]');
        if (!main || !target) return;
        const addons = this.addons || [];
        const amounts = this.bundleTotals(addons);
        const total = amounts.total;
        const compare = addons.length ? amounts.regular : main.compare;
        const discountBase = addons.length ? total : main.regular;
        target.textContent = this.format(total);
        const mrp = this.querySelector('[data-sticky-compare]');
        mrp.textContent = this.format(compare); mrp.hidden = compare <= total;
        const percent = compare > 0 ? Math.round((compare - discountBase) * 100 / compare) : 0;
        this.querySelector('[data-sticky-discount]').textContent = percent;
        this.querySelector('[data-sticky-discount-wrap]').hidden = percent <= 0;
        const label = this.querySelector('[data-sticky-selection]');
        if (label) { label.hidden = !addons.length; label.textContent = this.dataset.selectionLabel.replace('{count}',main.quantity + addons.reduce((sum,item) => sum + item.quantity, 0)); }
      }
      syncGallery(variant, attempt = 0) {
        window.clearTimeout(this.galleryTimer);
        const source = variant.featured_image?.src || variant.featured_media?.preview_image?.src;
        if (!source) return;
        const gallery = this.closest('.shopify-section')?.querySelector('media-gallery');
        if (!gallery) return;
        const imageKey = value => {
          if (!value) return '';
          try { return decodeURIComponent(new URL(value, location.href).pathname.split('/').pop()); } catch { return ''; }
        };
        const expected = imageKey(source);
        if (!expected) return;
        const image = Array.from(gallery.querySelectorAll('[media-gallery="image"] img')).find(candidate =>
          [candidate.currentSrc, candidate.getAttribute('src'), candidate.getAttribute('data-src'), candidate.getAttribute('data-srcset')?.split(',')[0]?.trim().split(/\s+/)[0]].some(value => imageKey(value) === expected)
        );
        const slide = image?.closest('[media-gallery="image"]');
        if (!slide) return;
        const container = gallery.querySelector('.swiper-wrapper-main') || gallery.querySelector('grid-gallery');
        if (container?.classList.contains('swiper')) {
          const slider = container.swiper;
          if (!slider?.initialized || slider.destroyed) {
            if (attempt < 10 && this.isConnected) this.galleryTimer = window.setTimeout(() => this.syncGallery(variant, attempt + 1), 100);
            return;
          }
          const position = Number(slide.dataset.swiperSlideIndex ?? Number(slide.dataset.position) - 1);
          if (!Number.isInteger(position) || position < 0) return;
          const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 250;
          if (slider.params.loop && typeof slider.slideToLoop === 'function') slider.slideToLoop(position, duration);
          else if (typeof slider.slideTo === 'function') slider.slideTo(position, duration);
        } else {
          slide.scrollIntoView({ block:'nearest', inline:'nearest', behavior:'instant' });
        }
      }
      async submit(event) {
        event.preventDefault();
        if (this.busy) return;
        const variant = this.variant();
        const quantity = this.form.querySelector('input[name="quantity"]:checked') || this.form.querySelector('input[name="quantity"][type="hidden"]:not(:disabled)');
        if (!variant?.available || !quantity || quantity.disabled || !this.form.reportValidity()) return;
        const destination = event.submitter?.dataset.destination || 'cart';
        let redirect = this.form.querySelector('input[name="return_to"]');
        if (!redirect) {
          redirect = document.createElement('input');
          redirect.type = 'hidden';
          redirect.name = 'return_to';
          this.form.append(redirect);
        }
        redirect.value = destination === 'checkout' ? `${this.dataset.rootUrl}checkout` : this.dataset.cartUrl;
        this.error.hidden = true;
        this.busy = true;
        this.setAttribute('aria-busy', 'true');
        this.update(false);
        if (destination === 'checkout') {
          try {
            if (typeof window.HeadlessCheckout?.checkout !== 'function') throw new Error('Checkout is still loading. Please try again in a moment.');
            const items = [{id:variant.id,quantity:Number(quantity.value)},...(this.addons || []).map(item=>({id:item.id,quantity:item.quantity}))];
            const response = await fetch(`${this.dataset.rootUrl}cart/add.js`, {
              method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
              body:JSON.stringify({items})
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || 'Unable to add these items. Please try again.');
            window.HeadlessCheckout.checkout();
          } catch (error) {
            this.error.textContent = error.message || 'Checkout could not open. Please try again.';
            this.error.hidden = false;
          } finally {
            this.busy = false; this.removeAttribute('aria-busy'); this.update(false);
          }
          return;
        }
        const drawer = document.querySelector('cart-drawer.ms-cart');
        if (drawer?.addItems) {
          try { await drawer.addItems([{id:variant.id,quantity:Number(quantity.value)},...(this.addons || [])], event.submitter); }
          catch(error) { this.error.textContent=error.message;this.error.hidden=false; }
          finally { this.busy=false;this.removeAttribute('aria-busy');this.update(false); }
          return;
        }
        let targetForm = this.form;
        if (this.addons?.length) {
          targetForm = document.createElement('form');
          targetForm.method = 'post'; targetForm.action = this.form.action; targetForm.hidden = true;
          const add = (name,value) => { const input=document.createElement('input'); input.type='hidden'; input.name=name; input.value=String(value); targetForm.append(input); };
          for (const [name,value] of new FormData(this.form)) { if (name !== 'id' && name !== 'quantity') add(name,value); }
          [{id:variant.id,quantity:Number(quantity.value)},...this.addons].forEach((item,index) => { add(`items[${index}][id]`,item.id); add(`items[${index}][quantity]`,item.quantity); });
          document.body.append(targetForm);
        }
        HTMLFormElement.prototype.submit.call(targetForm);
      }

    });
  }

  if (!customElements.get('maxsmile-delivery')) {
    customElements.define('maxsmile-delivery', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.querySelector('form');
        this.input = this.querySelector('input');
        this.button = this.querySelector('button');
        this.result = this.querySelector('[role="status"]');
        this.form.addEventListener('submit', event => { event.preventDefault(); this.check(); });
        this.input.addEventListener('input', () => {
          this.request?.abort(); this.sequence = (this.sequence || 0) + 1;
          this.button.disabled = false; this.result.hidden = true; this.input.removeAttribute('aria-invalid');
        });
      }
      disconnectedCallback() { this.request?.abort(); }
      today() {
        const parts = new Intl.DateTimeFormat('en-CA', {timeZone:'Asia/Kolkata',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
        const get = type => Number(parts.find(p => p.type === type).value);
        return new Date(Date.UTC(get('year'),get('month')-1,get('day'),12));
      }
      addDays(date, count) {
        const result = new Date(date);
        for (let i = 0; i < count;) { result.setUTCDate(result.getUTCDate()+1); if (result.getUTCDay() !== 0) i++; }
        return result;
      }
      zone(pin, offices) {
        if (this.dataset.localPins.split(/[,\s]+/).includes(pin)) return 'A';
        const fast = (this.dataset.fastCities || '').toLowerCase().split(',').map(x => x.trim()).filter(Boolean);
        if (offices.some(o => fast.includes((o.District || '').toLowerCase()) || fast.includes((o.State || '').toLowerCase()))) return 'A';
        if (offices.some(o => o.State?.toLowerCase() === this.dataset.state.toLowerCase())) return 'B';
        const special = /assam|arunachal|manipur|meghalaya|mizoram|nagaland|tripura|sikkim|jammu|kashmir|ladakh|himachal|kerala/i;
        return offices.some(o => special.test(o.State || '')) ? 'E' : 'D';
      }
      range(zone) {
        const min = Math.max(1, Number(this.dataset['days'+zone]) || 5);
        return [min, zone === 'D' ? min + 1 : min];
      }
      message(text, invalid = false) {
        this.dataset.status = invalid ? "error" : "result";
        this.result.textContent = text;
        if (!invalid && text.includes('\n')) {
          const lines=text.split('\n');
          const heading=document.createElement('strong');heading.textContent=lines.shift();
          this.result.replaceChildren(heading,document.createTextNode(lines.join(' · ')));
        }
        this.result.hidden = false;
        this.input.setAttribute('aria-invalid', String(invalid));
      }
      async check() {
        const pin = this.input.value.trim();
        this.request?.abort();
        const sequence = this.sequence = (this.sequence || 0) + 1;
        if (!/^[1-9][0-9]{5}$/.test(pin)) { this.message(this.dataset.invalid, true); return; }
        this.request = new AbortController();
        const request = this.request;
        const timer = setTimeout(() => request.abort(), 12000);
        this.button.disabled = true; this.message(this.dataset.loading);
        try {
          const response = await fetch('https://api.postalpincode.in/pincode/' + pin, {signal:request.signal,credentials:'omit'});
          if (!response.ok) throw new Error('lookup');
          const data = await response.json();
          if (sequence !== this.sequence) return;
          const offices = data?.[0]?.PostOffice;
          if (data?.[0]?.Status !== 'Success' || !offices?.length) { this.message(this.dataset.invalid,true); return; }
          const [min,max] = this.range(this.zone(pin,offices));
          const dispatch = this.today();
          const format = date => new Intl.DateTimeFormat('en-IN',{day:'numeric',month:'short',timeZone:'UTC'}).format(date);
          const from = format(this.addDays(dispatch,min)), to = format(this.addDays(dispatch,max));
          this.message(this.dataset.result.replace('{date}',from === to ? from : from + '–' + to).replace('{pincode}',pin).replace('{location}', offices[0].District || offices[0].State));
        } catch (error) {
          if (sequence === this.sequence) this.message(this.dataset.unavailable);
        } finally {
          clearTimeout(timer);
          if (sequence === this.sequence) this.button.disabled = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_maxsmile-rating"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('maxsmile-rating')) {
    customElements.define('maxsmile-rating', class extends HTMLElement {
      connectedCallback() {
        this._connectFrame = requestAnimationFrame(() => { if (this.isConnected) this.initialize(); });
      }
      initialize() {
        const total = this.querySelector('[data-review-total]');
        if (total) total.textContent = Number(total.dataset.reviewTotal).toLocaleString(document.documentElement.lang || undefined);
        if (this._controller) return;
        this._controller = new AbortController();
        const options = { signal: this._controller.signal };
        const benefit = this.querySelector('.maxsmile-rating__benefit');
        const items = [...this.querySelectorAll('[data-benefit]')];
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        const hover = matchMedia('(hover: hover) and (pointer: fine)');
        let index = 0;
        const rotate = () => {
          if (motion.matches || document.hidden || benefit?.open || (hover.matches && this.matches(':hover')) || this.querySelector(':focus-visible')) return;
          items[index]?.removeAttribute('data-active');
          index = (index + 1) % items.length;
          items[index]?.setAttribute('data-active', '');
        };
        if (items.length > 1) this._rotation = setInterval(rotate, Math.max(2, Number(this.dataset.rotationSeconds) || 3) * 1000);
        document.addEventListener('click', event => { if (benefit?.open && !benefit.contains(event.target)) benefit.open = false; }, options);
        this.addEventListener('keydown', event => { if (event.key === 'Escape' && benefit?.open) { benefit.open = false; benefit.querySelector('summary').focus(); } }, options);
        const photos = this.querySelector('.maxsmile-rating__photos');
        const updatePhotos = () => {
          let shown = 0;
          photos?.querySelectorAll('.maxsmile-rating__photo').forEach(link => {
            const visible = link.dataset.loaded === 'true' && shown < 4;
            link.hidden = !visible;
            link.toggleAttribute('data-first-visible', visible && shown === 0);
            if (visible) shown += 1;
          });
          if (photos) photos.hidden = shown === 0;
        };
        photos?.querySelectorAll('img').forEach(img => {
          const link = img.closest('.maxsmile-rating__photo');
          const loaded = () => {
            if (img.naturalWidth > 0) link.dataset.loaded = 'true';
            else link.remove();
            updatePhotos();
          };
          const failed = () => { link.remove(); updatePhotos(); };
          img.addEventListener('load', loaded, options);
          img.addEventListener('error', failed, options);
          if (img.complete) loaded();
        });
        this._photoClick = event => {
          const link = event.target.closest('.maxsmile-rating__photo');
          if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          const handled = !this.dispatchEvent(new CustomEvent('maxsmile:open-review-photo', {
            bubbles: true,
            cancelable: true,
            detail: { productId: this.dataset.productId, photo: link.href, author: link.dataset.reviewAuthor, text: link.dataset.reviewText, title: link.dataset.reviewTitle, rating: link.dataset.reviewRating, trigger: link }
          }));
          if (handled) event.preventDefault();
        };
        this.addEventListener('click', this._photoClick, options);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this._connectFrame);
        clearInterval(this._rotation);
        this._controller?.abort();
        this._controller = null;
        this._photoClick = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_maxsmile-review-cards"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('maxsmile-review-carousel')) {
    customElements.define('maxsmile-review-carousel', class extends HTMLElement {
      connectedCallback() {
        this._connectFrame = requestAnimationFrame(() => { if (this.isConnected) this.initialize(); });
      }
      initialize() {
        this.track = this.querySelector('.maxsmile-review-carousel__track');
        this.cards = [...this.querySelectorAll('.maxsmile-review-card')];
        if (!this.track || !this.cards.length || this._controller) return;
        this._controller = new AbortController();
        const options = { signal: this._controller.signal };
        this.dialog = this.querySelector('.maxsmile-review-dialog');
        if (this.dialog) {
          this.dialog.querySelector('[data-review-dialog-close]').addEventListener('click', () => this.dialog.close(), options);
          this.dialog.addEventListener('close', () => this.restoreAfterDialog(), options);
          this.dialog.addEventListener('click', event => {
            if (event.target !== this.dialog) return;
            const bounds = this.dialog.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
          }, options);
          const fullImage = this.dialog.querySelector('img');
          fullImage.addEventListener('load', () => { fullImage.hidden = fullImage.naturalWidth === 0; }, options);
          fullImage.addEventListener('error', () => { fullImage.hidden = true; }, options);
          document.addEventListener('maxsmile:open-review-photo', event => {
            if (event.defaultPrevented || event.detail?.productId !== this.dataset.productId) return;
            if (this.openPhoto(event.detail)) event.preventDefault();
          }, options);
        }
        this.previous = this.querySelector('[data-review-prev]');
        this.next = this.querySelector('[data-review-next]');
        this.current = this.querySelector('[data-review-current]');
        this.status = this.querySelector('.maxsmile-review-carousel__status');
        const controls = this.querySelector('.maxsmile-review-carousel__controls');
        if (controls) controls.hidden = false;
        this.index = 0;
        this.previous?.addEventListener('click', () => this.goTo(this.index - 1), options);
        this.next?.addEventListener('click', () => this.goTo(this.index + 1), options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this._frame);
          this._frame = requestAnimationFrame(() => this.update());
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          const direction = event.key === 'ArrowRight' ? (rtl ? -1 : 1) : event.key === 'ArrowLeft' ? (rtl ? 1 : -1) : 0;
          if (!direction) return;
          event.preventDefault();
          this.goTo(this.index + direction);
        }, options);
        this.track.addEventListener('toggle', () => this.syncHeight(), { ...options, capture: true });
        this._resize = new ResizeObserver(() => this.update());
        this._resize.observe(this.track);
        this.cards.forEach(card => this._resize.observe(card));
        this.dataset.enhanced = 'true';
        this.update();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.pauseButton = this.querySelector('[data-review-pause]');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        if (this.pauseButton) {
          this.pauseButton.hidden = this.cards.length < 2;
          this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.schedule(); }, options);
        }
        this.addEventListener('pointerenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
        this.track.addEventListener('pointerdown', () => { this.paused = true; this.schedule(); }, options);
        this.track.addEventListener('toggle', () => this.schedule(), { ...options, capture:true });
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.schedule(); }, options);
        this._visibility = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.schedule(); }, {threshold:0.5});
        this._visibility.observe(this);
      }
      schedule() {
        clearTimeout(this._slideTimer);
        if (this.pauseButton) {
          this.pauseButton.textContent = this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
          this.pauseButton.setAttribute('aria-pressed', String(this.paused));
        }
        if (this.paused || this.hovered || this.focused || !this.inView || document.hidden || this.cards.length < 2 || this.querySelector('details[open]')) return;
        this._slideTimer = setTimeout(() => {
          this.goTo((this.index + 1) % this.cards.length);
          this.schedule();
        }, Math.max(5, Number(this.dataset.interval) || 7) * 1000);
      }
      openPhoto(details) {
        if (!this.dialog || typeof this.dialog.showModal !== 'function' || !details.photo) return false;
        this._dialogTrigger = details.trigger;
        this.dialog.querySelector('[data-review-dialog-author]').textContent = details.author?.trim() || this.dataset.customerLabel;
        this.dialog.querySelector('[data-review-dialog-text]').textContent = details.text?.trim() || details.title?.trim() || '';
        const rating = Math.max(0, Math.min(5, Number(details.rating) || 0));
        const stars = this.dialog.querySelector('[data-review-dialog-rating]');
        stars.textContent = '★'.repeat(Math.round(rating));
        stars.setAttribute('aria-label', this.dataset.ratingLabel.replace('__RATING__', String(rating)));
        const fullImage = this.dialog.querySelector('img');
        fullImage.hidden = true;
        fullImage.src = details.photo;
        if (fullImage.complete && fullImage.naturalWidth > 0) fullImage.hidden = false;
        if (!this.dialog.open) {
          this._previousBodyOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          this._scrollLocked = true;
          this.dialog.showModal();
        }
        this.dialog.scrollTop = 0;
        this.dialog.querySelector('[data-review-dialog-close]').focus({ preventScroll: true });
        return true;
      }
      restoreAfterDialog() {
        if (this._scrollLocked) { document.body.style.overflow = this._previousBodyOverflow; this._scrollLocked = false; }
        if (this._dialogTrigger?.isConnected) this._dialogTrigger.focus({ preventScroll: true });
        this._dialogTrigger = null;
      }
      goTo(index) {
        const target = this.cards[Math.max(0, Math.min(index, this.cards.length - 1))];
        if (!target) return;
        const trackRect = this.track.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const distance = rtl ? targetRect.right - trackRect.right : targetRect.left - trackRect.left;
        this.track.scrollBy({ left: distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        const rect = this.track.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        let nearest = 0;
        let distance = Infinity;
        this.cards.forEach((card, index) => {
          const cardRect = card.getBoundingClientRect();
          const gap = Math.abs(rtl ? cardRect.right - rect.right : cardRect.left - rect.left);
          if (gap < distance) { distance = gap; nearest = index; }
        });
        const changed = this.index !== nearest;
        this.index = nearest;
        if (this.previous) this.previous.disabled = nearest === 0;
        if (this.next) this.next.disabled = nearest === this.cards.length - 1;
        if (this.current) this.current.textContent = String(nearest + 1);
        if (changed && this.status) this.status.textContent = this.dataset.positionLabel.replace('__CURRENT__', String(nearest + 1));
        this.syncHeight();
      }
      syncHeight() {
        const activeCard = this.cards?.[this.index];
        if (!activeCard || !this.track) return;
        const height = Math.ceil(activeCard.getBoundingClientRect().height) + 4;
        if (height > 4 && Math.abs((parseFloat(this.track.style.height) || 0) - height) > .5) this.track.style.height = `${height}px`;
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.restoreAfterDialog();
        cancelAnimationFrame(this._connectFrame);
        this._controller?.abort();
        this._controller = null;
        this._resize?.disconnect();
        this._visibility?.disconnect();
        clearTimeout(this._slideTimer);
        delete this.dataset.enhanced;
        if (this.track) this.track.style.removeProperty('height');
        cancelAnimationFrame(this._frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
